import { render, staticRenderFns } from "./assemble-details.vue?vue&type=template&id=26ab79a2&scoped=true"
import script from "./assemble-details.vue?vue&type=script&lang=js"
export * from "./assemble-details.vue?vue&type=script&lang=js"
import style0 from "./assemble-details.vue?vue&type=style&index=0&id=26ab79a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ab79a2",
  null
  
)

export default component.exports